"use client";
import { useState } from 'react';

let REF_CACHE: string | null | undefined = undefined;
const KEYS = ['ref', 'referral', 'referrer'];

function computeReferral(): string | null {
  if (typeof window === 'undefined') return null;
  const params = new URLSearchParams(window.location.search);
  for (const k of KEYS) {
    const v = params.get(k);
    if (v?.trim()) return v.trim();
  }
  return null;
}

export function getInitialReferral(): string | null {
  if (REF_CACHE !== undefined) return REF_CACHE;
  REF_CACHE = computeReferral();
  return REF_CACHE;
}

export function useStableReferral(): string | null {
  const [ref] = useState<string | null>(() => getInitialReferral());
  return ref;
}
